<template>
  <div class="subaccount_box">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="子账号管理" name="subaccount">用户管理</el-tab-pane>
      <el-tab-pane label="角色管理" name="role">角色管理</el-tab-pane>
      <el-tab-pane label="权限管理" name="authority">配置管理</el-tab-pane>
    </el-tabs> -->
    
    <div class="temp_t_btn" @click="addSubAccount">新增账号</div>
    <el-table
      :data="tableData"
      class="main_table">
      <!-- <el-table-column
        type="selection"
        width="55" /> -->
      <el-table-column
        prop="nickname"
        label="昵称">
        <template slot-scope="scope">
          {{ scope.row.nickname }}{{ scope.row.id == $store.state.userInfo.id ? '(我)' : '' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号" />
      <el-table-column
        prop="roles"
        label="角色">
        <template slot-scope="scope">
          {{ scope.row.roles[0].name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="roles"
        label="查看权限">
        <template slot-scope="scope">
          {{ scope.row.roles[0].description }}
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间" />
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button type="text" @click="editSubAccount(scope.row)" v-if="userRole.key != 'employee' || scope.row.id == $store.state.userInfo.id">编辑</el-button>
          <el-button type="text" style="color: #F72D2D" @click="delSubAccount(scope.row.id)" v-if="userRole.key != 'employee'">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      class="main_pagination"
      background
      layout="prev, pager, next"
      :total="tableTotal">
    </el-pagination> -->
    <el-drawer
      class="main_drawer"
      :title="ruleForm.id ? '编辑账号' : '新增账号'"
      :visible.sync="addDrawer"
      direction="rtl"
      :wrapperClosable="false">
      <div class="main_drawer_body">
        <el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="昵称" prop="nickname">
            <el-input v-model="ruleForm.nickname" placeholder="请输入账号昵称"></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="role_ids" v-if="userRole.key != 'employee'">
            <el-select v-model="ruleForm.role_ids" placeholder="请选择角色">
              <el-option :label="item.name" :value="item.id" v-for="item in roleList"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="ruleForm.mobile" placeholder="请输入手机号" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="ruleForm.password" placeholder="请输入密码" show-password autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="main_drawer_footer">
        <el-button class="drawer_confirm" @click="handleSubmitForm" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
        <el-button class="drawer_cancel" @click="addDrawer=false">取 消</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { allSubGetList, subGetList, roleGetList, permissionGetList, subCreate, subUpdate, subDelete } from '@/api/subaccount'
export default {
  name: "subaccount",
  data () {
    let self = this
   return {
    activeName: 'authority',
    roleList: [],
    tableData: [],
    tableTotal: 100,

    addDrawer: false,
    loading: false,
    ruleForm: {
      nickname: '',
      role_ids: 9,
      mobile: '',
      password: ''
    },
    rules: {
      mobile: [{required: true, pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }],
      password: [{
        validator: (rule, value, callback) => {
          if(!self.ruleForm.id || (self.ruleForm.id && value)) {
            if(value.length < 6 || value.length > 20) {
              callback(new Error('密码需6-20个字符'))
            }else {
              callback()
            }
          }else {
            callback()
          }
        }, trigger: 'blur'}]
    }
   }
  },
  created() {
    this.getRoleList()
    this.getSubAccountList()
  },
  computed: {
    userRole() {
      return this.$store.getters.userRole
    }
  },
  methods:{
    handleClick(tab) {
      console.log(tab);
      
      if(tab.name == 'role') {
        this.getRoleList()
      }else if(tab.name == 'authority') {
        this.getPermissionList()
      }
    },
    addSubAccount() {
      if(this.ruleForm.id) {
        delete this.ruleForm.id
      }
      this.ruleForm.nickname = ''
      this.ruleForm.role_ids = ''
      this.ruleForm.mobile = ''
      this.ruleForm.password = ''
      this.addDrawer = true
    },
    editSubAccount(row) {
      this.ruleForm.id = row.id
      this.ruleForm.nickname = row.nickname
      this.ruleForm.role_ids = row.roles[0].id
      this.ruleForm.mobile = row.mobile
      this.ruleForm.password = ''
      this.addDrawer = true
    },
    handleSubmitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          let dataform = {...this.ruleForm}
          dataform.role_ids = [dataform.role_ids]
          if(dataform.id) {
            subUpdate(dataform.id, dataform).then(res => {
              this.loading = false
              this.addDrawer = false
              this.$message.success('编辑成功')
              this.getSubAccountList()
            })
          }else {
            subCreate(dataform).then(res => {
              this.loading = false
              this.addDrawer = false
              this.$message.success('创建成功')
              this.getSubAccountList()
            })
          }
        }
      })
    },
    delSubAccount(id) {
      this.$confirm('是否删除该账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        subDelete(id).then(res => {
          this.$message.success('删除成功')
          this.getSubAccountList()
        })
      })
    },
    getSubAccountList() {
      allSubGetList().then(res => {
        this.tableData = res.data
      })
    },
    getRoleList() {
      roleGetList().then(res => {
        this.roleList = res.data
      })
    },
    getPermissionList() {
      permissionGetList().then(res => {
        this.tableData = res.data
      }) 
    }
  }
}
</script>
<style lang="scss" scoped>
.subaccount_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .temp_t_btn {
    border-radius: 8px;
    background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
    font-size: 20px;
    font-weight: 500;
    color: #F7F8FA;
    width: 171px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    margin-bottom: 24px;
    cursor: pointer;
  }
}
</style>